import React from "react"
import { useEffect } from "react"
import { useState } from "react"
import {
  DISCLAIMER_VIEW_HEADING,
  GO_TO_AVAILABLE_VIEW_TEXT,
  NAV_LINKS,
  UNAVAILABLE_VIEWS_BODY_TEXT,
  UNAVAILABLE_VIEWS_LIST_TEXT,
  VIEW_NOT_AVAILABLE_HEADING_TEXT,
} from "../../constants"
import { Modal } from "../../UIKit/components"
import {
  ListItem,
  ModalBodyWrapper,
  ParagraphText,
  PrimaryButtonLink,
  UnorderedList,
} from "../../UIKit/styles"
import { getIsViewCompleted } from "../../utils/utils"

export default function UnavailableViewModal({ path, navLinks }) {
  const [isOpen, setIsOpen] = useState(false)
  const [nextAvailableView, setNextAvailableView] = useState(null)

  useEffect(() => {
    const initialiseView = () => {
      const incompleteViews = getIncompleteViews()
      setNextAvailableView(incompleteViews[0])
      setIsOpen(incompleteViews.length > 0)
    }
    initialiseView()
    return () => {
      setIsOpen(false)
    }
  }, [path])

  const decodeComputedString = (string, data) => {
    if (!data) return string
    const computedLabel = (labelString, data) => {
      return new Function("return `" + labelString + "`;").call(data)
    }
    return computedLabel(string, data)
  }

  const getIncompleteViews = () => {
    const currentIndex = navLinks.findIndex((view) => view.path === path)
    if (currentIndex === -1) return []

    return navLinks.slice(0, currentIndex).filter((view, i) => {
      if (i === navLinks.length - 1) return false
      return view.disabled || !getIsViewCompleted(view.path)
    })
  }
  return (
    <Modal
      isOpen={isOpen}
      allowClose={false}
      body={
        <ModalBodyWrapper>
          <ParagraphText>{UNAVAILABLE_VIEWS_LIST_TEXT}</ParagraphText>
          <UnorderedList>
            {getIncompleteViews().map(({ title }) => (
              <ListItem key={`incomplete-view-${title}`}>{title}</ListItem>
            ))}
          </UnorderedList>
          <ParagraphText>{UNAVAILABLE_VIEWS_BODY_TEXT}</ParagraphText>
          {nextAvailableView && (
            <PrimaryButtonLink to={nextAvailableView.path}>
              {decodeComputedString(
                GO_TO_AVAILABLE_VIEW_TEXT,
                nextAvailableView
              )}
            </PrimaryButtonLink>
          )}
        </ModalBodyWrapper>
      }
      title={VIEW_NOT_AVAILABLE_HEADING_TEXT}
    />
  )
}
